import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Volumes } from './components/sections/Volumes';
import { Deliverables } from './components/sections/Deliverables';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { AboutDoctor } from './components/sections/AboutDoctor';
import { FAQ } from './components/sections/FAQ';
import { FinalChoice } from './components/sections/FinalChoice';
import { SiteFooter } from './components/sections/SiteFooter';
export function App() {
  return <div className="w-full overflow-x-hidden bg-cream" data-id="element-0" data-mp="3ijxpqrsp22kf">
      <MetaPixel data-id="element-1" data-mp="3ij61k21ff746" />
      <main className="w-full pb-28 sm:pb-32" data-id="element-2" data-mp="3ijpef4c7z5bc">
        <Hero data-id="element-3" data-mp="3ml17xky7saot" />
        <BeforeAfter data-id="element-4" data-mp="3mkhmvvd9p66k" />
        <PainPoints data-id="element-5" data-mp="3mjzpgvevclx2" />
        <Volumes data-id="element-6" data-mp="3mj6hjr46bqdc" />
        <Deliverables data-id="element-7" data-mp="3rcj6y3gog175" />
        <Bonuses data-id="element-8" data-mp="3rbzngibdp4r0" />
        <Offer data-id="element-9" data-mp="3rdkgu4lyihna" />
        <Guarantee data-id="element-10" data-mp="3rd19fhtxnbni" />
        <Testimonials data-id="element-11" data-mp="3relvsk63foaa" />
        <AboutDoctor data-id="element-12" data-mp="6hrlipoilfp" />
        <FAQ data-id="element-13" data-mp="4wwnrzgd0hb" />
        <FinalChoice data-id="element-14" data-mp="5gfrc0u9uwx" />
      </main>
      <SiteFooter data-id="element-15" data-mp="7sxbo2oq39g" />
      <FloatingCTA triggerId="primary-cta" data-id="element-16" data-mp="2zld43f9knpe6" />
      <PurchasePopup data-id="element-17" data-mp="2zmo6pbra6r3p" />
    </div>;
}